import { BookingPreferredArea, BookingType } from 'types/booking';

const _helpers = {
	checkGtagEnabled: (): boolean => typeof window.gtag === 'function',
	checkGTMEnabled: (): boolean => typeof window.dataLayer === 'object',
	addEcommerceEvent: (
		event: Gtag.EventNames | string,
		param: Gtag.EventParams | Record<string, any>,
		items?: Gtag.Item[]
	) => {
		if (_helpers.checkGtagEnabled()) {
			return window.gtag?.('event', event, { ...param, items });
		}

		if (!_helpers.checkGTMEnabled()) return;

		return window.dataLayer?.push({ event, ecommerce: { ...param, items } });
	},
};

const _checkIsEcommerceAvailable = () => _helpers.checkGtagEnabled() || _helpers.checkGTMEnabled();

const _getEcommerceURL = (url: string, encode: boolean = true) => {
	const withEcommerce = window.analytics?.isGa || window.analytics?.isGtm;

	if (!withEcommerce) return url;

	const querySing = url.includes('?') ? `&` : `?`;
	const _url = `${url}${querySing}with-ecommerce-events=true`;

	if (encode) encodeURI(_url);

	return _url;
};

// Custom event for booking request
const _addBookingRequestCustomEvent = ({ booking }: { booking: BookingType }) => {
	const params: Gtag.EventParams & Record<string, any> = {
		booking_id: booking.guid,
		person_count: booking.personCount ?? 0,
		date: booking.dateTime,
		num: booking.num ?? 0,
		visit_duration: booking.visitDuration ?? 0,
		status: booking.status,
	};

	if (booking.deposit?.amount) {
		params.deposit = booking.deposit.amount / 100;
		params.currency = booking.deposit?.currency;
	}

	return _helpers.addEcommerceEvent('booking_request', params);
};

// Custom event for booking select preferred area
const _selectBookingPreferredAreaCustomEvent = ({ area }: { area: BookingPreferredArea }) => {
	const params: Gtag.EventParams & Record<string, any> = {
		area_id: area._id,
		name: area.name,
	};

	return _helpers.addEcommerceEvent('booking_select_area', params);
};

export const EcommerceEventsHelper = {
	isEcommerceAvailable: _checkIsEcommerceAvailable,
	getEcommerceURL: _getEcommerceURL,
	addBookingRequest: _addBookingRequestCustomEvent,
	selectBookingPreferredArea: _selectBookingPreferredAreaCustomEvent,
};
